export default function TestimonialSection() {
  const testimonials = [
    {
      name: '김민수',
      role: '개인 고객',
      rating: 5,
      comment: '차량 상태도 좋고 직원분들도 친절하셔서 매우 만족스러웠습니다. 다음에도 꼭 이용하겠습니다!',
      avatar: 'https://public.readdy.ai/ai/img_res/fc7d785f9f81e716b543e27121b96e07.jpg'
    },
    {
      name: '이지은',
      role: '가족 여행',
      rating: 5,
      comment: '가족 여행으로 SUV를 빌렸는데 넓고 편안해서 아이들도 너무 좋아했어요. 무료 배달 서비스도 정말 편리했습니다.',
      avatar: 'https://readdy.ai/api/search-image?query=friendly%20korean%20woman%20portrait%20with%20warm%20smile%20in%20casual%20professional%20attire%20with%20clean%20white%20background%20and%20soft%20lighting&width=200&height=200&seq=avatar-002&orientation=squarish'
    },
    {
      name: '박준호',
      role: '출장 고객',
      rating: 5,
      comment: '출장 때마다 이용하는데 항상 깔끔하고 연비도 좋아서 만족합니다. 예약 시스템도 간편해요.',
      avatar: 'https://readdy.ai/api/search-image?query=confident%20korean%20professional%20man%20portrait%20in%20business%20casual%20wear%20with%20clean%20white%20background%20and%20professional%20studio%20lighting&width=200&height=200&seq=avatar-003&orientation=squarish'
    },
    {
      name: '최수진',
      role: '신혼여행',
      rating: 5,
      comment: '신혼여행으로 제주도에서 렌트했는데 차량도 새것같고 서비스도 완벽했어요. 강력 추천합니다!',
      avatar: 'https://readdy.ai/api/search-image?query=elegant%20korean%20woman%20portrait%20with%20gentle%20smile%20in%20modern%20professional%20setting%20with%20clean%20white%20background%20and%20natural%20lighting&width=200&height=200&seq=avatar-004&orientation=squarish'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            고객 후기
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            실제 이용하신 고객님들의 생생한 후기를 확인해보세요
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-5 md:p-6 shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center mb-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover object-top mr-3 md:mr-4"
                />
                <div>
                  <h4 className="text-sm sm:text-base md:text-lg font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-xs sm:text-sm text-gray-500">{testimonial.role}</p>
                </div>
              </div>

              <div className="flex mb-3 md:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-base md:text-lg"></i>
                ))}
              </div>

              <p className="text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed">
                "{testimonial.comment}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
